import { AsyncPipe } from "@angular/common";
import {
  ChangeDetectionStrategy,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  ElementRef,
  inject,
} from "@angular/core";
import { RouterModule } from "@angular/router";
import { Store } from "@ngrx/store";

import { AuthenticationService } from "../../../core/_services/authentication.service";
import { isUserAdmin, isUserOwner } from "../../../core/store/authentication";
import { AppState } from "../../../core/store/store";
import { ClickOutsideDirective } from "../../_directives/click-outside.directive";

const imports = [ClickOutsideDirective, RouterModule, AsyncPipe];
@Component({
  selector: "app-side-nav",
  templateUrl: "./side-nav.component.html",
  styleUrl: "./side-nav.component.scss",
  imports,
  changeDetection: ChangeDetectionStrategy.OnPush,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SideNavComponent {
  private el = inject(ElementRef);
  private store = inject<Store<AppState>>(Store);

  authentication = inject(AuthenticationService);
  isAdmin$ = this.store.select(isUserAdmin);
  isOwner$ = this.store.select(isUserOwner);

  closeMenu(): void {
    const sideNav = this.el.nativeElement.querySelector(
      "saf-side-nav"
    ) as HTMLElement | null;

    if (sideNav && sideNav.getAttribute("state") === "open") {
      const shadowRoot = sideNav.shadowRoot;
      if (shadowRoot) {
        const button = shadowRoot.querySelector(
          'saf-button[aria-expanded="true"]'
        ) as HTMLElement;

        if (button) {
          button.click();
          sideNav.setAttribute("state", "closed");
        }
      }
    }
  }

  // Workaround: Addresses a bug where the saf-menu-item stays highlighted (selected) after the mouse cursor leaves the item.
  onMouseLeave(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    target.classList.remove("selected");
  }
}
